// Cuddo: shared behavior (nav, reveals, drawn lines, ambient glow)
(() => {
  const nav = document.getElementById('nav');
  const root = document.documentElement;
  let lastSolid = null;
  let lastGlow = null;

  function onScroll() {
    const y = window.scrollY;
    const solid = y > 40;
    if (solid !== lastSolid) { nav.classList.toggle('solid', solid); lastSolid = solid; }
    const max = Math.max(1, document.documentElement.scrollHeight - innerHeight);
    const glow = Math.round(20 + (y / max) * 60);
    if (glow !== lastGlow) { root.style.setProperty('--glow-y', glow + '%'); lastGlow = glow; }
  }
  addEventListener('scroll', onScroll, { passive: true });
  onScroll();

  const targets = document.querySelectorAll('[data-reveal], .draw, .details-photo');
  if (!('IntersectionObserver' in window)) {
    targets.forEach(el => el.classList.add('in'));
    return;
  }
  const io = new IntersectionObserver(entries => {
    entries.forEach(e => {
      if (e.isIntersecting) { e.target.classList.add('in'); io.unobserve(e.target); }
    });
  }, { rootMargin: '0px 0px -12% 0px', threshold: 0.08 });
  targets.forEach(el => io.observe(el));
})();
